import { color } from '@internal/plugin-components-react';

export const lastSyncWrapperStyle = {
  backgroundColor: color.ui.blue[100],
  border: `1px solid ${color.ui.blue[700]}`,
  borderRadius: 8,
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  width: 'fit-content',
  textTransform: 'none',
};

export const iconWrapperStyle = {
  borderRadius: '50%',
  backgroundColor: color.ui.blue[700],
  marginRight: 12,
  width: 16,
  height: 16,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const iconStyle = {
  color: color.ui.blue[100],
  width: 13,
  height: 13,
};
